import { roles } from "./constants";

export const urls = {
    api: {
        clinics: {
            getAll: { url: '/api/clinics', method: 'GET' },
            get(id) {
                return { url: `/api/clinics/${id}`, method: 'GET' };
            },
            update: { url: '/api/clinics', method: 'PUT' },
            add: { url: '/api/clinics', method: 'POST' }
        },
        clients: {
            getAll: { url: '/api/clients', method: 'GET' },
            getMain: { url: '/api/clients/main', method: 'GET' },
            get(id) {
                return { url: `/api/clients/${id}`, method: 'GET' };
            },
            delete(id) {
                return { url: `/api/clients/${id}`, method: 'DELETE' };
            },
            order(id) {
                return { url: `/api/clients/order/${id}`, method: 'GET' };
            },
            sync: { url: `/api/clients/sync`, method: 'POST' },
            syncAllToCM(skipCliniko) {
                return { url: `/api/clients/syncalltocm?skipCliniko=${skipCliniko}`, method: 'POST' };
            },
            update: { url: '/api/clients', method: 'PUT' },
            updateTransactionalEmail: { url: '/api/clients/updateTransactionalEmail', method: 'POST' },
            add: { url: '/api/clients', method: 'POST' }
        },
        cronexpressions: {
            getAll: { url: '/api/cronexpressions', method: 'GET' },
            get: { url: (id) => `/api/cronexpressions/${id}`, method: 'GET' },
            update: { url: '/api/cronexpressions', method: 'PUT' },
            add: { url: '/api/cronexpressions', method: 'POST' },
            delete: { url: '', method: 'DELETE' }
        },
        chores: {
            getAll: { url: '/api/chores', method: 'GET' },
            get: { url: (id) => `/api/chores/${id}`, method: 'GET' },
            update: { url: '/api/chores', method: 'PUT' },
            add: { url: '/api/chores', method: 'POST' },
            delete: { url: '/api/chores', method: 'DELETE' }
        },
        notificationchores: {
            getAll: { url: '/api/notificationchores', method: 'GET' },
            get: { url: (id) => `/api/notificationchores/${id}`, method: 'GET' },
            update: { url: '/api/notificationchores', method: 'PUT' },
            updateActive: { url: '/api/notificationchores/updateactive', method: 'PUT' },
            updateName: { url: '/api/notificationchores/updatename', method: 'PUT' },
            add: { url: '/api/notificationchores', method: 'POST' },
            retry: { url: '/api/notificationchores/retry', method: 'POST' },
            quote: { url: '/api/notificationchores/quote', method: 'POST' },
            delete: { url: '/api/notificationchores', method: 'DELETE' },
            getHistory(id, page) {
                return {
                    url: `/api/notificationchores/history/${id}?page=${page}`, method: 'GET'
                };
            },
            getVersions(id) {
                return {
                    url: `/api/notificationchores/version/${id}`, method: 'GET'
                };
            }
        },
        ensure: {
            get: (id) => {
                return { url: `/api/ensure/${id}`, method: 'GET' };
            }
        },
        campaignMonitor: {
            getSession: { url: '/api/WordPressAPI/CampaignMonitor', method: 'GET' }
        }
    },
    router: {
        clinics: {
            index: { url: '/clinics', roles: [roles.Admin, roles.Owner] },
            details: { url: '/clinics/:id', roles: [roles.Admin, roles.Owner] }
        },
        clients: {
            index: { url: '/clients', roles: [roles.Admin, roles.Owner] },
            redirect: { url: '/client', roles: [roles.Admin, roles.Owner] },
            details: { url: '/clients/:id', roles: [roles.Admin, roles.Owner] }
        },
        cronexpressions: {
            index: { url: '/cronexpressions', roles: [roles.Admin] },
            details: { url: '/cronexpressions/:id', roles: [roles.Admin] }
        },
        chores: {
            index: { url: '/chores', roles: [roles.Admin] },
            details: { url: '/chores/:id', roles: [roles.Admin] }
        },
        notificationchores: {
            index_old: { url: '/notificationchores', roles: [roles.Admin, roles.Owner] },
            index: { url: '/sms', roles: [roles.Admin, roles.Owner] },
            details: { url: '/sms/:id', roles: [roles.Admin, roles.Owner] },
            copy: { url: '/sms/:id/copy', roles: [roles.Admin, roles.Owner] },
            history: { url: '/sms/:id/history/:page?', roles: [roles.Admin, roles.Owner] },
            version: { url: '/sms/:id/version/:page?', roles: [roles.Admin, roles.Owner] }
        },
        transactionalchores: {
            index_old: { url: '/transactionalchores', roles: [roles.Admin, roles.Owner] },
            index: { url: '/email', roles: [roles.Admin, roles.Owner] },
            details: { url: '/email/:id', roles: [roles.Admin, roles.Owner] },
            copy: { url: '/email/:id/copy', roles: [roles.Admin, roles.Owner] },
            history: { url: '/email/:id/history/:page?', roles: [roles.Admin, roles.Owner] },
            version: { url: '/email/:id/version/:page?', roles: [roles.Admin, roles.Owner] }
        },
        store: {
            index: { url: '/store', roles: [roles.Admin, roles.Owner] },
            details: { url: '/store/:id', roles: [roles.Admin, roles.Owner] },
            confirm: { url: '/order/:id', roles: [roles.Admin, roles.Owner], allowNotInIframe: true }
        },
        campaignMonitor: {
            index: { url: '/campaignmonitor', roles: [roles.Admin, roles.Owner] }
        },
        logs: {
            index: { url: '/logs', roles: [roles.Admin] }
        },
        optout: {
            sms: { url: '/optout/sms/:id', roles: [] },
            email: { url: '/optout/email/:id', roles: [] }
        }
    },
    hideLayout: [
        '/campaignmonitor',
        '/endsession',
        '/notificationchores*',
        '/notificationchorehistory/*',
        '/store*'
    ]
};


// WEBPACK FOOTER //
// ./src/urls.js